import axios, { AxiosResponse } from "axios";
import {IQuestionnaire} from "./express-help-client.type";
import {BaseTable} from "mixins/types";

/**
 * Список опросов
 */
export const getAllQuestionnaires = (): Promise<AxiosResponse<BaseTable<IQuestionnaire>>> => {
  return axios.get(`/services/isnaportal/open-api/admin/questionnaire`, {
    params: {
      sort: 'questionnaireWeight',
      size: 100
    }
  });
};

/**
 * Получение опроса по ID
 * @param id
 */
export const getQuestionnaireById = (id: number): Promise<AxiosResponse<IQuestionnaire>> => {
  return axios.get(`/services/isnaportal/open-api/admin/questionnaire/${id}`);
};
